import Vue from 'vue';
import App from './App.vue';
import store from "./store";
import SlideUpDown from 'vue-slide-up-down'
import tap from '@kk/tap';
import {_dealImageSuffix} from '@/js/compress.js'
import * as Integrations from '@sentry/integrations';
import lazyLoad from '@kk/vue-lazy';
import {compress} from '@kk/utils';
import {ua, qs} from '@kkmh/utils';
import xss from './js/xss';
 
Vue.directive("xss", function(el, binding) {
    el.innerHTML = xss(binding.value);
});
lazyLoad.setDefaultBuffer(window.innerHeight);
Vue.use(lazyLoad);

Vue.component('slide-up-down', SlideUpDown)

import "./css/flex.css";

// 接入 sentry
if (process.env.VUE_APP_HOST_ENV == 'production') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
    ignoreErrors: [
      'subscribeListenerOnViewBack',
      'recivefreecardinfo',
      'Promise',
      'xhr error:0'
    ],
    beforeSend (event) {
      if (event.exception && event.exception.values && event.exception.values[0]) {
        event.exception.values[0].value = event.exception.values[0].value + "【@广告IP图形 - @ljj】";
      }
      return event;
    }
  });
}

tap(document.body);
Vue.config.productionTip = false;
Vue.prototype._dealImageSuffix = _dealImageSuffix;

window.onscroll = () => {
  try {
    const y = document.body.scrollTop || document.documentElement.scrollTop;
    const wrap = document.getElementById('detail');
    if (!wrap) return;
    const { x:wrapx = 0, y:wrapy = 0, height:wraph = 0 } = wrap.getBoundingClientRect();
    const btn = document.getElementById('btnsle');
    if (!btn) return;
    
    // 顶部时
    if (wrapy > 0) {
      btn.style.transform = `translate3d(0px, 0px, 0px)`;
      return;
    }
    // 底部时
    if (-wrapy > wraph - 250) {
      btn.style.transform = `translate3d(0px, ${wraph - 250}px, 0px)`;
      return;
    }
    // requestAnimationFrame(() => {
    //   btn.style.transform = `translate3d(0px, ${-wrapy}px, 0px)`;  
    // });
    // setTimeout(() => {
      btn.style.transform = `translate3d(0px, ${-wrapy}px, 0px)`;  
    // }, 500);
  } catch (error) {
    console.warn(error);
  }
}

async function init () {
    try {
      window.getListData = await window.getListPromise;
    } catch(error) {
      window.getListData = {};
    }

    Vue.mixin({
      data () {
        return {
        };
      },
      filters: {
        compress
      },
      methods: {
        imgCompress (url, size, isPng = false) {
          return compress(url, size, isPng);
        },
        bgCompress (url, size, isPng = false) {
          return `url('${compress(url, size, isPng)}')`;
        },
      }
    });

    new Vue({
      store,
      render: h => h(App),
      created(){
         
      },
      mounted(){
        
      },
    }).$mount('#app');
}

init();